/*
 * @Author: bbqin
 * @Date: 2022-06-22 09:35:29
 * @LastEditTime: 2023-02-02 11:12:23
 * @LastEditors: bbqin
 * @Description: 给登录页封装的一些工具方法。
 * @FilePath: \Platform_Front\src\platform\api\loginUtils.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { setGlobalStorage, getGlobalStorage } from './storage';
import { syncAjax } from './ajaxsync';
import { opaqueEncrypt, opaqueDecrypt } from './cipher';
import Gzip from './gzip';
import Cryptograph from './cryptograph';


// 添加一个加签处理方法 -- by bbqin
function addDataSign(data, userCode, {
    allin = false,
    headers = {},
}) {
    // console.log(data, userCode);
    if (
        typeof transSn === 'undefined' ||
        typeof transSign === 'undefined' ||
        // !userCode ||
        (headers && headers['Content-Type'] == 'multipart/form-data') // newData.append(  这种模式 先确定下 需不需要加签操作
    ) {
        return data;
    }
    // 先加签全部数据 或者部分数据

    // 这里会影响原字符串 （编码、位数？）导致后台解析不了字符串
    if (!allin) {
        let strDataSign = data.busiParamJson + '';
        // 加签 -- bbqin
        data.sysParamJson.sn = transSn(userCode);
        data.sysParamJson.signdata = transSign(strDataSign, userCode);
    } else {
        // 加签 -- bbqin
        // data.sysParamJson.sn = transSn(userCode);
        let dataStr = JSON.stringify(data) + '';
        headers['Identifications'] = transSign(dataStr, '');
    }
    // 这里是通过对象方式注入  headers  不符合设计原则 TODO 
    return data;
}

// 生成aes
function createAES() {
    const cryptograph = new Cryptograph();
    let cowboy = getGlobalStorage('localStorage', 'cowboy');
    let aeskeyCahe = cowboy ? opaqueDecrypt(cowboy) : cryptograph.generateSecretKey();

    // localStorage.removeItem('rockin');
    localStorage.removeItem('rockinlog');

    return aeskeyCahe;
}

const getRandom = () => {
    if (!window.crypto && (window).msCrypto) {
        (window).crypto = (window).msCrypto;
    }
    return window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296;

};

// 生成uuid
function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (getRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

// resetSysSwitch
function resetSysSwitch(aeskey, callback) {

    let cowboy = getGlobalStorage('localStorage', 'cowboy') || opaqueEncrypt(aeskey);
    // 如果浏览器器中出现了两个用户  以第一个用户的为主  保持同一个浏览器中唯一
    setGlobalStorage('localStorage', 'cowboy', cowboy); // 当前的

    let cookiets = Date.now(); //双cookie验证 liuxis
    //let gziptools = new Gzip();

    // 给工作桌面用

    // gzip
    // let gzipData = {
    //     sysParamJson: {
    //         busiaction: '查询请求流量压缩开关',
    //         pagecs: cookiets,
    //     },
    // };
    // // add by bbqin  特殊加签
    // // 为了避免headers冲突 这里要修正下 
    // let gzipHeaders = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
    // gzipData = JSON.stringify(addDataSign(gzipData, '', { allin: true, headers: gzipHeaders }));
    // syncAjax({
    //     type: 'post',
    //     url: '/nccloud/platform/gzip/switch.do',
    //     data: gzipData,
    //     headers: gzipHeaders,
    //     async: false,
    //     success: asd => {
    //         asd = typeof asd === 'string' ? JSON.parse(asd) : asd;
    //         if (asd) {
    //             if (asd.success) {
    //                 if (asd.data) {
    //                     setGlobalStorage('localStorage', 'gzip', 1);
    //                 } else {
    //                     setGlobalStorage('localStorage', 'gzip', 0);
    //                 }
    //             }
    //         }
    //     },
    // });

    // 给工作桌面用
    // rockin
    // let gzipSwitch = getGlobalStorage('localStorage', 'gzip');
    // let aesRequestData = {
    //     sysParamJson: {
    //         busiaction: '查询请求aes加密开关', /* 国际化处理： 查询请求aes加密开关*/
    //         pagecs: cookiets,
    //     },
    // };
    // // add by bbqin  特殊加签
    // // 为了避免headers冲突 这里要修正下 
    // let aesHeaders = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
    // aesRequestData = addDataSign(aesRequestData, '', { allin: true, headers: aesHeaders });

    // aesRequestData = gzipSwitch == '1' ? gziptools.zip(JSON.stringify(aesRequestData)) : JSON.stringify(aesRequestData);
    // syncAjax({
    //     type: 'post',
    //     url: '/nccloud/platform/aes/switch.do',
    //     data: aesRequestData,
    //     async: false,
    //     headers: aesHeaders,
    //     success: asd => { // aesSwitchData
    //         asd = typeof asd === 'string' ? JSON.parse(asd) : asd;
    //         asd = gzipSwitch == '1' ? gziptools.unzip(asd) : (typeof asd === 'string' ? JSON.parse(asd) : asd);
    //         if (asd.success) {
    //             setGlobalStorage('localStorage', 'rockin', !!asd.data);
    //             setGlobalStorage('localStorage', 'rockinlog', asd.data ? 1200 : 1201);
    //         }
    //     },
    //     error: function (res) {
    //         setGlobalStorage('localStorage', 'rockinlog', 1404);
    //     },
    // });

    // 更新开关
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    let totalRequestData = {
        sysParamJson: {
            busiaction: '查询系统开关',
            pagecs: cookiets,
            ts: new Date().getTime(),
        },
    };
    let totalHeaders = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
    totalRequestData = JSON.stringify(addDataSign(totalRequestData, '', { allin: true, headers: totalHeaders }));
    syncAjax({
        type: 'post',
        url: '/nccloud/platform/total/switch.do',
        async: false,
        headers: totalHeaders,
        data: totalRequestData,
        success: res => {
            if (res) {
                res = JSON.parse(res);
                if (res.data) {
                    NCC_SYS_Switch = res.data || {};
                    let localStorageSwitch = localStorage.getItem('storeCipher');
                    //缓存是否加密开关变化了
                    if (localStorageSwitch != NCC_SYS_Switch.localStorage) {
                        //localStorage加密开关与上次不一致，则清空所有localStorage内容
                        localStorage.clear();
                    }
                    localStorage.setItem('NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                    //开启关闭自动化测试开关
                    localStorage.setItem('storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');

                    //给工作桌面使用
                    setGlobalStorage('localStorage', 'gzip', NCC_SYS_Switch.gzip ? 1: 0);
                    setGlobalStorage('localStorage', 'rockin', NCC_SYS_Switch.aesKey);
                    setGlobalStorage('localStorage', 'rockinlog', NCC_SYS_Switch.aesKey ? 1200 : 1201);

                    setGlobalStorage('localStorage', '_ncc_automated_', NCC_SYS_Switch.automated_test ? '1' : '0');
                    setGlobalStorage('localStorage', '_ncc_extend_style_', NCC_SYS_Switch.extendstyle ? '1' : '0');
                    callback && callback();
                }
            }
        },
        error: function () {
            setGlobalStorage('localStorage', 'rockinlog', 1404);
        },
    });

}

const loginUtils = { uuidv4, createAES, resetSysSwitch };

window.loginUtils = loginUtils;

export { uuidv4, createAES, resetSysSwitch };